import BaseTabs from './BaseTabs';

class ProgramScheduleTabs extends BaseTabs {
  constructor() {
    super('program-schedule-tabs');
  }

  static init() {
    new ProgramScheduleTabs();
  }
}

export default ProgramScheduleTabs;
